import React from 'react';
import './App.css';
import Nav from './components/nav/nav'
import Form from './components/form/form'
import Page404 from "./components/Page404/Page404";
import Instructions from "./components/Instructions/Instructions";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import "./stylesheets/style.css"
import "./stylesheets/decode.css"

function App() {
    return (
        <div className="App">
            <Nav/>
            <div className="container">
                <Router>
                    <Routes>
                        <Route path="/form/:articleId" element={<Form/>}/>
                        <Route path="/instructions" element={<Instructions/>}/>
                        <Route path='*' element={<Page404/>}/>
                    </Routes>
                </Router>
            </div>
        </div>
    );
}

export default App;
